export default __webpack_public_path__ + "static/media/img20.dcbb3635.jpg";